// extracted by mini-css-extract-plugin
export default {"title":"ReportUserModal_title__xp+Lx","form":"ReportUserModal_form__rG-0N","field":"ReportUserModal_field__Yy8Gy","submitButton":"ReportUserModal_submitButton__yGzYA"};